import { FormularioRelatorioComponent } from './formulario-relatorio/formulario-relatorio.component';
import { empresaObj, reportName } from './../../shared/Util';
import { ControlStatusService } from './../../shared/control-status.service';
import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from './formulario-relatorios';
import { FormularioRelatorioControlService } from './formulario-relatorio-control.service';
import { Observable } from 'rxjs';
import { DashboardService } from '../../dashboard/dashboard.service';
import { AsyncPipe } from '@angular/common';


declare let $: any
@Component({
    selector: 'app-modal-formuilario-relatorios',
    templateUrl: './modal-formuilario-relatorios.component.html',
    styleUrls: ['./modal-formuilario-relatorios.component.css'],
    standalone: true,
    imports: [FormularioRelatorioComponent, AsyncPipe]
})
export class ModalFormuilarioRelatoriosComponent implements OnInit {
  title = '';
  formFields: Observable<FormField<any>[]>;
  formulario: FormGroup
  listaEmpresas: Array<empresaObj> = []
  empresaChaveValor: { key: any, value: string }[] = [];


  constructor(private service: FormularioRelatorioControlService, private dashBoardService: DashboardService, private controlStatus: ControlStatusService) {
    this.formFields = service.getFormFields();

  }

  async ngOnInit() {
    await this.getEmpresas()
    if (this.controlStatus.tipoRelatorio) {
      this.defineInputsRelatorios()
    }
  }


  async getEmpresas() {
    await this.dashBoardService.getEmpresas().then(response => {
      this.listaEmpresas = response
    })

    this.listaEmpresas.forEach(empresa => {
      this.empresaChaveValor.push({
        key: empresa.cdEmp, value: empresa.NomeFantazia
      })
    })
  }


  defineInputsRelatorios() {
    let formArray: Array<FormField<any>> = [];

    formArray.push(new FormField<string>({
      controlType: "dateInicio",
      key: 'dtInicio',
      label: 'Data Inicial.',
      required:true,
      type: 'date',
      order: 2
    }),
      new FormField<string>({
        controlType: "dateFinal",
        key: 'dtFinal',
        label: 'Data Final.',
        required:true,
        type: 'date',
        order: 3
      }),
      new FormField({
        controlType: 'textbox',
        key: 'roteiro',
        label: 'Roteiro:',
        order: 5
      })
   );

    if (this.listaEmpresas.length > 0) {
      formArray.push(new FormField({
        controlType: 'dropdown',
        key: 'empresa',
        label: 'Empresa',
        options: this.empresaChaveValor,
        order: 4
      }))
    }

    switch (this.controlStatus.tipoRelatorio) {
      case 1:
        this.title = 'ROTEIRO DE ENTREGAS NO CLIENTE';
        this.controlStatus.reportName = reportName.RoteiroEntregasClientePDF;
        this.controlStatus.reportName2 = reportName.RoteiroEntregasClienteEXCEL;
        this.controlStatus.reportFolder = 'ROTENTR';
        break;
      case 2: this.title = 'OCORRÊNCIAS'
        this.title = 'OCORRÊNCIAS NO CLIENTE';
        this.controlStatus.reportName = reportName.OcorrenciasPDF;
        this.controlStatus.reportName2 = reportName.OcorrenciasEXCEL;
        this.controlStatus.reportFolder = 'ROTOC';
        break;
      case 3: this.title = 'ROTEIROS POR MOTORISTA'
        this.controlStatus.reportName = reportName.RoteirosMotoristaPDF;
        this.controlStatus.reportName2 = reportName.RoteirosMotoristaEXCEL;
        this.controlStatus.reportFolder = 'ROTPM';
        break;
      case 4: this.title = 'OCORRÊNCIAS POR MOTORISTA'
        this.title = 'OCORRÊNCIAS POR MOTORISTA';
        this.controlStatus.reportName = reportName.OcorrenciasMotoristaPDF;
        this.controlStatus.reportName2 = reportName.OcorrenciasMotoristaEXCEL;
        this.controlStatus.reportFolder = 'ROTOCP';
        break;
      case 5: this.title = 'ROTEIROS DO DIA'
        this.title = 'ROTEIROS DO DIA';
        this.controlStatus.reportName = reportName.RoteirosDiaPDF;
        this.controlStatus.reportName2 = reportName.RoteirosDiaEXCEL;
        this.controlStatus.reportFolder = 'ROTDIA';
        formArray = []; //nao usa parametros
        break;
      case 6: this.title = 'TEMPO MÉDIO DE ENTREGA POR CLIENTE'
        this.title = 'TEMPO MÉDIO';
        this.controlStatus.reportName = reportName.TempoMedioEntregaClientePDF;
        this.controlStatus.reportName2 = reportName.TempoMedioEntregaClienteEXCEL;
        this.controlStatus.reportFolder = 'ROTTC';
        break;
      case 7: this.title = 'INTERVALO DE ENTREGA POR CLIENTE'
        this.controlStatus.reportName = reportName.IntervaloEntregaClientePDF;
        this.controlStatus.reportName2 = reportName.IntervaloEntregaClienteEXCEL;
        this.controlStatus.reportFolder =  'ROTINTC';
        break;
      case 8: this.title = 'JORNADA DE TRABALHO DO MOTORISTA'
        this.controlStatus.reportName = reportName.JornadaTrabalhoMotoristaPDF;
        this.controlStatus.reportName2 = reportName.JornadaTrabalhoMotoristaEXCEL;
        this.controlStatus.reportFolder = 'ROTTABM'; //todo - remover parametro de roteiro
        break
      case 9: this.title = 'FORMA DE PAGAMENTO'
        this.controlStatus.reportName = reportName.FormaPagamentoPDF;
        this.controlStatus.reportName2 = reportName.FormaPagamentoEXCEL;
        this.controlStatus.reportFolder = 'ROTFP';
        break;
      case 10: this.title = 'CUSTO POR ENTREGA'
        this.controlStatus.reportName = reportName.CustoRoteiroPorEntregaPDF;
        this.controlStatus.reportName2 = reportName.CustoRoteiroPorEntregaExcel;
        this.controlStatus.reportFolder = 'ROTCUF';
        break;
      case 11: this.title = 'OCORRÊNCIAS DE CUSTO EXTRA POR ROTEIRO'
        this.controlStatus.reportName = reportName.OcorrenciasCustoExtraPDF;
        this.controlStatus.reportName2 = reportName.OcorrenciasCustoExtraEXCEL;
        this.controlStatus.reportFolder = 'OCEXTROT';
        break;
      case 12: 
        this.title = 'AVALIAÇÃO DE ENTREGAS POR MOTORISTA'
        this.controlStatus.reportName = reportName.AvaliacaoEntregaMotoristaPDF;
        this.controlStatus.reportName2 = reportName.AvaliacaoEntregaMotoristaEXCEL;
        this.controlStatus.reportFolder = 'ROTAVAMOT';
        formArray.push(new FormField({
          controlType: 'textbox',
          key: 'motorista',
          label: 'Motorista',
          required: false,
          order: 5
        }))
        break;
    }

    formArray.push(
      new FormField<string>({
        controlType: "radio",
        key: 'fileFormat',
        label: 'Formato de Arquivos:',
        type: 'radio',
        value: 'excel',
        options: [
          { key: '1', value: 'pdf' },
          { key: '2', value: 'excel' },
        ],
        order: 1
      }));
      
    this.formFields = this.service.getFormFields(formArray)
  }


  fechaModal() {
    $('#modalRelJasper').modal('hide')
    this.controlStatus.limpaEstadoRelatorios()
    this.title = ''

  }
}
